import { formatDate } from '@/ui';

export const formatTextValue = (value: string | null | undefined): string =>
  value && value.trim().length > 0 ? value : '-';

export const formatDateValue = (value: Date | string | null | undefined): string =>
  value ? formatDate(value) : '-';
